module.exports = __webpack_public_path__ + "b6cf121c144f8cc68d57083ce90abb1b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-steve-03.jpg
 ** module id = 373
 ** module chunks = 0
 **/